import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import './ResetPasswordModal.css';
import PasswordInput from '../../../../../../../components/passwordInput/PasswordInput';
import { profileRepository } from '../../../../../../../repositories/profileRepository';
import { toastr } from 'react-redux-toastr';
import { InputText } from '../../../../../../../components/InputText';
import { Label } from '../../../../../../../components/Label';
import { Text } from '../../../../../../../components/Text';
import { Button } from '../../../../../../../components/Button';

const ResetPasswordModal = ({ show, onHide }) => {
  const [current, setCurrent] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const isFormValid = () => {
    return (
      current.trim() !== '' && newPass.trim() !== '' && confirm.trim() !== ''
    );
  };
  const handleSubmit = async () => {
    try {
      const data = {
        currentPassword: current,
        newPassword: newPass,
        confirmPassword: confirm,
      };
      const response = await profileRepository.resetPassword(data);
      if (response.status === 200) {
        toastr.success('Senha alterada com sucesso!');
        setCurrent('');
        setNewPass('');
        setConfirm('');
        onHide();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        'Erro ao alterar senha. Tente novamente.';
      handleErrorToastr(errorMessage);
    } finally {
      return;
    }
  };
  const handleErrorToastr = (message) => {
    if (message === 'Novas senhas não são iguais') {
      return toastr.error(
        message,
        'Verifique a nova senha e a confirmação, após isso, tente novamente',
      );
    } else if (message === 'Senha atual inválida') {
      return toastr.error(message, 'Verifique a senha atual e tente novamente');
    }
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="reset-password-modal-dialog modal-70w"
      contentClassName="reset-password-modal-content"
    >
      <Modal.Header closeButton={false} style={{ padding: '0 0 10px 0' }}>
        <Modal.Title className="w-100 text-center">
          <div style={{ fontWeight: 'bold' }}>Troca a Senha</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ paddingTop: 0 }}>
        <div className="reset-password-info">
          Informe os dados abaixo para efetuar a troca da senha
        </div>
        <Form>
          <div>
            <Label>Senha Atual</Label>
            <InputText
              value={current}
              type="password"
              onChange={(e) => setCurrent(e.target.value)}
            />
          </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                height: '100%',
              }}
            >
              <Label>Nova Senha</Label>
              <Text color="red400" size="xs">
                Mín. 6 caracteres
              </Text>
            </div>
            <InputText
              value={newPass}
              type="password"
              onChange={(e) => setNewPass(e.target.value)}
            />
          </div>
          <div>
            <Label>Confirme a Nova Senha</Label>
            <InputText
              value={confirm}
              type="password"
              onChange={(e) => setConfirm(e.target.value)}
            />
          </div>
          <br />
          <Button
            color="green450"
            onClick={handleSubmit}
            disabled={!isFormValid()}
          >
            Trocar Senha
          </Button>
        </Form>
        <div
          className="reset-password-help mt-3"
          style={{ fontSize: 13, color: '#d44' }}
        >
          Em caso de dúvidas ou problemas, contate o{' '}
          <a href="mailto:ouvidoria@sobrerodas.club" style={{ color: '#d44' }}>
            ouvidoria@sobrerodas.club
          </a>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResetPasswordModal;
